var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0B1F47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hjk4ufsjra)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.991 9.106c1.022 0 1.85-.834 1.85-1.862a1.856 1.856 0 0 0-1.85-1.862c-1.021 0-1.85.834-1.85 1.862s.829 1.862 1.85 1.862z",
    fill: "#FFC009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.051 8.022.003-.006a1.866 1.866 0 0 0-1.68-2.641 1.85 1.85 0 0 0-1.681 1.083l-5.62 12.274.005.002c-.109.237-.17.501-.17.78 0 1.027.829 1.861 1.85 1.861.797 0 1.476-.506 1.737-1.217l5.544-12.11.012-.026z",
    fill: "#328FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7 8.022-.003-.007c-.11-.237-.17-.5-.17-.779 0-1.028.828-1.861 1.85-1.861a1.85 1.85 0 0 1 1.68 1.082l5.62 12.275-.005.002c.109.237.17.5.17.779a1.857 1.857 0 0 1-1.85 1.862 1.851 1.851 0 0 1-1.736-1.217L11.71 8.048l-.012-.026z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.991 11.385c-1.021 0-1.85.833-1.85 1.861v6.318h.002a1.855 1.855 0 0 0 1.849 1.81 1.855 1.855 0 0 0 1.849-1.81h.001v-6.318a1.856 1.856 0 0 0-1.85-1.861z",
    fill: "#328FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.374 19.033c1.022 0 1.85-.834 1.85-1.862a1.856 1.856 0 0 0-1.85-1.861c-1.022 0-1.85.833-1.85 1.861s.828 1.862 1.85 1.862z",
    fill: "#FFC009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hjk4ufsjra"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.908 5.375)",
    d: "M0 0h14.933v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenai);
export default __webpack_public_path__ + "static/media/openai.773bbf57e45410cbb67e16ea6829f076.svg";
export { ForwardRef as ReactComponent };